module.exports = __webpack_public_path__ + "static/PMB_stones_instructions-0c5e73176c51ac4a51fa8fee0407d834.png";